import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var RepulseBase = /*#__PURE__*/function () {
  function RepulseBase() {
    _classCallCheck(this, RepulseBase);
    this.distance = 200;
    this.duration = 0.4;
    this.factor = 100;
    this.speed = 1;
    this.maxSpeed = 50;
    this.easing = "ease-out-quad";
  }
  _createClass(RepulseBase, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.distance !== undefined) {
        this.distance = data.distance;
      }
      if (data.duration !== undefined) {
        this.duration = data.duration;
      }
      if (data.easing !== undefined) {
        this.easing = data.easing;
      }
      if (data.factor !== undefined) {
        this.factor = data.factor;
      }
      if (data.speed !== undefined) {
        this.speed = data.speed;
      }
      if (data.maxSpeed !== undefined) {
        this.maxSpeed = data.maxSpeed;
      }
    }
  }]);
  return RepulseBase;
}();